<template>
  <tr v-if="$parent.$parent.$parent.rerender">
    <td
      v-bind:class="{
        'has-error': $parent.hasError(index, 'UF_VID_GROUP_ID')
      }"
    >
      <input type="hidden" v-model="item.ID" />
      <select
        v-model="item.UF_VID_GROUP_ID"
        class="sel-dropdown i-main-style"
        :disabled="$parent.$parent.$parent.projectDisabled"
        @change="$parent.removeError(index, 'UF_VID_GROUP_ID')"
      >
        <option
          v-for="g in directory.tree_group_cifra_oborudovanie"
          v-bind:value="g.ID"
          v-bind:key="g.ID"
          v-text="g.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{ $parent.errorText(index, "UF_VID_GROUP_ID") }}
      </div>
    </td>
    <td
      v-bind:class="{
        'has-error': $parent.hasError(index, 'UF_VID_ID')
      }"
    >
      <select
        v-model="item.UF_VID_ID"
        class="sel-dropdown i-main-style "
        style="width: 300px"
        :disabled="$parent.$parent.$parent.projectDisabled"
        @change="$parent.removeError(index, 'UF_VID_ID')"
      >
        <option
          v-for="g in cGroup"
          v-bind:value="g.ID"
          v-bind:key="g.ID"
          v-text="g.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{ $parent.errorText(index, "UF_VID_ID") }}
      </div>
    </td>
    <td
      v-bind:class="{
        'has-error': $parent.hasError(index, 'UF_COUNT')
      }"
    >
      <input
        type="text"
        v-model="item.UF_COUNT"
        class="i-main-style t-co-executor-style"
        :disabled="$parent.$parent.$parent.projectDisabled"
        @keyup="$parent.removeError(index, 'UF_COUNT')"
      />
      <div class="error-text">
        {{ $parent.errorText(index, "UF_COUNT") }}
      </div>
    </td>
    <td
      v-bind:class="{
        'has-error': $parent.hasError(index, 'UF_DESCRIPTION')
      }"
    >
      <textarea
        v-model="item.UF_DESCRIPTION"
        class="i-main-style t-co-executor-style"
        :disabled="$parent.$parent.$parent.projectDisabled"
        @keyup="$parent.removeError(index, 'UF_DESCRIPTION')"
      ></textarea>
      <div class="error-text">
        {{ $parent.errorText(index, "UF_DESCRIPTION") }}
      </div>
    </td>
    <td>
      <a
        v-show="!$parent.$parent.projectDisabled"
        v-on:click="$parent.deleteItem(index)"
        class="link-delete-row"
      ></a>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DIRECTORY } from "@/store/actions.type";

export default {
  props: ["item", "index"],
  name: "digital_solution_list",

  mounted() {
    this.$store
      .dispatch(FETCH_DIRECTORY, ["tree/group_cifra_oborudovanie"])
      .then(() => {}, this);
  },
  computed: {
    cGroup() {
      if (this.item.UF_VID_GROUP_ID < 1) {
        return [];
      }
      let t = this.directory.tree_group_cifra_oborudovanie.filter(
        c => c.ID === this.item.UF_VID_GROUP_ID
      );
      if (t.length > 0) {
        return t[0].CHILD;
      }
      return [];
    },
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
